import { isHTTPError, type BeforeErrorHook } from "ky";

import { env } from "@/config";
import { getSharedApiClient } from "@/shared-utils";

// ky keeps the request body on an HTTPError, and failed calls are logged whole, so without this a failed
// call would log the session summary or the phone number.
const dropRequestBody: BeforeErrorHook = ({ error }) => {
    if (isHTTPError(error)) error.options = { ...error.options, body: undefined };
    return error;
};

/** No retries, though ky already skips them for POST: a retried C360 write could record the call twice. */
export const getC360ApiClient = (sessionId: string) =>
    getSharedApiClient(sessionId).extend(() => ({
        prefix: `${env.backendUrls.apiBaseUrl}/api/c360`,
        retry: { limit: 0 },
        hooks: { beforeError: [dropRequestBody] },
    }));
